import { FC, Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import { useMotionMode } from './useMotionMode';
import './site.css';

const ScrollOnNavigate: FC = () => {
    const { hash } = useLocation();

    useEffect(() => {
        const target = hash ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;

        if (target) {
            target.scrollIntoView?.({ behavior: 'smooth' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [hash]);

    return null;
};

const SiteLayout: FC = () => {
    const motion = useMotionMode();
    const { pathname } = useLocation();

    return (
        <div className="site" data-motion={motion}>
            <div className="site-bloom" aria-hidden="true" />
            <SiteHeader />
            <main className="site-main">
                <Suspense fallback={<div className="site-loading" aria-busy="true" />}>
                    <div className="view" key={pathname}>
                        <ScrollOnNavigate />
                        <Outlet />
                    </div>
                </Suspense>
            </main>
            <SiteFooter />
        </div>
    );
};

export default SiteLayout;
